import React from 'react';

import { AlmaLink } from '../alma-link';
import { AnchorLink } from '../anchor-link';

const Divider = () => {
	return (
		<hr
			style={{
				margin: '1.25rem auto',
				color: 'var(--grey-300)',
				height: '1px',
			}}
		/>
	);
};

export const serializers = {
	types: {
		cta: ({ node }) => {
			return <AlmaLink cta={{ ...node }} />;
		},
		divider: Divider,
	},
	marks: {
		link: ({ children, mark }) => {
			const openInNewTab = mark.openInNewTab === true;
			return (
				<a
					target={openInNewTab ? '_blank' : '_self'}
					rel={openInNewTab ? 'noopener noreferrer' : undefined}
					href={mark.href}
				>
					{children}
				</a>
			);
		},
		anchorLink: ({ children, mark }) => (
			<AnchorLink mark={mark}>{children}</AnchorLink>
		),
		fontAdjustments: ({ children }) => {
			console.log('Unknown mark - fontAdjustments: ', children);
		},
	},
};
